var map = {
	"./base.webp": "55e1",
	"./battlestar.webp": "16d2",
	"./colossus.webp": "0d7c",
	"./divinewind.webp": "3d9d",
	"./gunship.webp": "e4d1",
	"./nightstalker.webp": "abb8",
	"./orkocraft.webp": "44ae",
	"./salvation.webp": "6da4",
	"./thunderbird.webp": "8d30",
	"./ubiquity.webp": "4d31",
	"./vampship.webp": "3630"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb95";